import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import throttle from 'lodash.throttle';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { inViewForReact } from 'utils/common';
import makeRequest from 'utils/makeRequest';
import HorizontalLazyLoad from 'components_v2/common/HorizontalLazyLoad';
import CardBottom from 'components_v2/common/CardV2/CardBottom';
import Morebtn from 'components_v2/mobile/Morebtn';
import VsCard from '../../../../../components_v2/common/VsCard';
import SubsectionList from '../../../../../components_v2/mobile/SubsectionList/SubsectionList';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
import InViewObserver from 'components/InViewObserver/InViewObserver';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
import ImageV2 from 'components_v2/common/ImageV2';
// eslint-disable-next-line import/first
import classNames from 'classnames';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import s from './MixedSlider.scss';
import { TOI_LIVE_MOBILE_DOMAIN } from '../../../../../constants';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class MixedSlider extends React.Component {
  constructor(props) {
    super(props);
    const verticalLazyLoad = Boolean(
      !props.sectionData.items && props.sectionData.dataUrl,
    );
    this.state = {
      isClientSide: false,
      verticalLazyLoad,
      dataUrl: props.sectionData ? props.sectionData.dataUrl : undefined,
      isLoading: false,
    };

    this.ref = React.createRef();
  }

  componentDidMount() {
    const { sectionData } = this.props;
    this.setState({
      isClientSide: true,
      nextUrl: sectionData.nextPageData,
      items: sectionData.items,
    });
    if (this.props.gaData) {
      this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
      window.addEventListener('scroll', this.throttledGAonScroll);
    }
  }

  removeScrollEvent = () => {
    if (typeof this.throttledGAonScroll === 'function') {
      window.removeEventListener('scroll', this.throttledGAonScroll);
    }
  };

  handleGAOnScroll = () => {
    if (
      this.ref &&
      this.ref.current &&
      inViewForReact(this.ref.current, 0, true)
    ) {
      this.sendGA(this.props.gaData);
      this.removeScrollEvent();
    }
  };

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };
  sendGAOnCLick = (
    item,
    index,
    cardType,
    vsSectionName = '',
    vType,
    ga4Type,
  ) => {
    const { clickGaAction } = this.props;
    let data = {};
    if (typeof item.gaData !== 'undefined' && item.gaData.gaAction) {
      data = item.gaData;
    } else if (item === 'MoreClicked') {
      data.gaAction = `click`;
      data.gaLabel = `${
        cardType === 'Visual Stories' ? 'more_visualstories' : 'more_viralnews'
      }`;
    } else if (clickGaAction) {
      data.gaAction = clickGaAction;
      data.gaLabel = `${index + 1}_${item.wu}`;
    } else if (vType === 'visualStory') {
      data.gaAction = `${
        vsSectionName
          ? `click-${cardType}-${vsSectionName}`
          : `click-${cardType}`
      }`;
      data.gaLabel = `${index + 1}_${item.wu}`;
    } else if (vType === 'LatestStartupNews') {
      data.gaAction = `click-${cardType
        .replace(/ /g, '')
        .toLowerCase()}-${index}`;
      data.gaLabel = item.wu;
    } else {
      data.gaAction = `${cardType}_Card${index + 1}`;
      data.gaLabel = item.wu;
    }

    sendGaThroughProps({
      data,
    });

    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga4Type,
        category: `${'story_click'}`,
        story_no: `${index + 1}`,
        msid: item?.id,
      });
    }
  };

  getUpdatedData = resetCallback => {
    if (this.state.nextUrl) {
      makeRequest.get(this.state.nextUrl, 'skipfeedengine').then(data => {
        if (data && data.data && data.data.items) {
          this.setState({
            items: [...this.state.items, ...data.data.items],
            nextUrl: data.data.nextPageData,
          });

          if (data.data.nextPageData && typeof resetCallback === 'function') {
            setTimeout(resetCallback, 0);
          }
        }
      });
    }
  };
  moreCTA() {
    const { sectionData = {}, ga4Type, ga4Category } = this.props;
    if (sectionData && sectionData.name && sectionData.path) {
      return (
        <Morebtn
          moreText={
            sectionData.moreText
              ? sectionData.moreText
              : `More ${sectionData.name}`
          }
          absoluteMoreText={
            sectionData.moreText
              ? sectionData.moreText
              : `More ${sectionData.name}`
          }
          moreLink={sectionData.path}
          doNotChangeURL={sectionData.dnc === '1'}
          target={sectionData.target === '1'}
          btnClass={s.moreBtn}
          linkData={{
            gaAction: `click-${sectionData.name}-morestories`,
            gaLabel: `${sectionData.path}`,
          }}
          ga4Type={ga4Type}
          ga4Category={ga4Category}
        />
        // <div className={s.morelink}>
        //   <Link
        //     to={this.props.sectionData.path}
        //     onClick={() =>
        //       this.sendGAOnCLick(
        //         'MoreClicked',
        //         '_',
        //         this.props.sectionData.name,
        //         '',
        //         '',
        //       )
        //     }
        //   >
        //     More {this.props.sectionData.name}
        //   </Link>
        // </div>
      );
    }
    return null;
  }

  customOnError = e => {
    e.target.onerror = null;
    e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
  };

  loadData = () => {
    if (this.state.dataUrl && this.state.verticalLazyLoad) {
      makeRequest
        .get(this.state.dataUrl, 'skipfeedengine')
        .then(data => {
          if (data && data.data && data.data.items) {
            this.setState({
              items: data.data.items,
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  getSliderHtml(lazyloadData) {
    const { theme } = this.props;
    // const imageSize =
    //   this.props.theme === 'cardtype1' ? 'height-235,width-140,' : '';
    let cardType;
    if (
      this.props.sectionData &&
      this.props.sectionData.name === 'Viral News'
    ) {
      cardType = 'ViralNews';
    } else if (
      this.props.sectionData &&
      (this.props.sectionData.name === 'Visual Stories' ||
        this.props.sectionData.name === 'News Visual Stories')
    ) {
      cardType = 'visualStory';
    } else if (this.props.sectionData && this.props.sectionData.name) {
      cardType = this.props.sectionData.name.replace(/ /g, '');
    }

    const { sectionData, ga4Type } = this.props;
    const items = this.state.items || sectionData.items;
    const ImageElement = ImageV2;
    const vcardSection =
      this.props.sectionData &&
      this.props.sectionData.name === 'Latest Startup News'
        ? 'LatestStartupNews'
        : 'visualStory';
    const vCardSec =
      // eslint-disable-next-line no-nested-ternary
      this.props.sectionData && this.props.sectionData.name === 'Viral News'
        ? 'ViralNews'
        : vcardSection;
    const imgWidth =
      sectionData && sectionData.feedclass === 'visualstoriesas'
        ? '300'
        : '267';
    let html = (
      <React.Fragment>
        {items &&
          Array.isArray(items) &&
          items.map((item, index) => (
            <div className={`${s[theme]} ${s.linkWrapper}`}>
              {cardType === 'visualStory' && (
                <VsCard
                  title={item?.hl}
                  msid={item?.imageid}
                  thumbsize={item?.imagesize}
                  wu={item?.wu}
                  isWapView
                  lazyloadImg // ={this.props.lazyloadImg}
                  sectionName={item.category || item.secname}
                  index={item}
                  key={`vscard_${item?.wu || index}`}
                  isToiWidget={this.props.isToiWidget}
                  ga4Type={ga4Type}
                  gaIndex={index + 1}
                />
              )}
              {cardType !== 'visualStory' && (
                <Link
                  onClick={() =>
                    this.sendGAOnCLick(
                      item,
                      index,
                      cardType,
                      item.secname,
                      vCardSec,
                      ga4Type,
                    )
                  }
                  key={item.id}
                  to={item.wu}
                  doNotChangeURL={item.dnc === '1'}
                  data={item.gaData ? item.gaData : null}
                  target={item.target}
                >
                  <div className={`${s.thumbLink}`}>
                    <div className={s.content}>
                      {/* <img
                  src={`https://static.toiimg.com/photo/${imageSize}msid-${
                    item.imageid
                  }.cms`}
                  alt=""
                /> */}
                      <ImageElement
                        msid={item.imageid}
                        width={imgWidth}
                        placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
                        alt=""
                        lazyload
                        onError={this.customOnError}
                        offsetVertical={300}
                      />
                    </div>
                  </div>
                  <div
                    className={`${
                      this.props.theme === 'cardtype1'
                        ? s.textcard1
                        : s.textcard2
                    } ${s.storyText}`}
                  >
                    <span>{item.hl}</span>
                    {item.category && (
                      <span className={s.category}>{item.category}</span>
                    )}
                  </div>
                </Link>
              )}
              {item &&
                item.secdetail &&
                (item.secdetail.displayTime ||
                  (item.secdetail.hl && item.secdetail.wu)) && (
                  <div className={s.CardBottomWrap}>
                    <CardBottom secdetail={item.secdetail} />
                  </div>
                )}
            </div>
          ))}
      </React.Fragment>
    );
    if (this.state.isClientSide && lazyloadData) {
      html = (
        <HorizontalLazyLoad
          callback={this.getUpdatedData}
          classes={`${s.slider}`}
          marginFromRight="100"
        >
          {html}
        </HorizontalLazyLoad>
      );
    } else {
      html = <div className={s.slider}>{html}</div>;
    }
    return html;
  }

  loadLayoutData = dataUrl => {
    this.setState({ isLoading: true });
    makeRequest
      .get(dataUrl, 'skipfeedengine')
      .then(data => {
        if (data && data.data && data.data.items) {
          this.setState({
            items: data.data.items,
            isLoading: false,
          });
        }
      })
      .catch(err => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  };

  render() {
    if (
      (!this.props.sectionData ||
        !this.props.sectionData.items ||
        this.props.sectionData.items.length === 0) &&
      !(this.state.verticalLazyLoad && this.state.dataUrl)
    ) {
      return null;
    }
    const sliderId =
      this.props.sectionData.id &&
      (this.props.sectionData.id === 'recipes' ||
        this.props.sectionData.id === '74211819')
        ? 'recipes'
        : '';
    const feedclass =
      (this.props.sectionData && this.props.sectionData.feedclass) || '';
    const themeName = classNames({
      [s.infographics_wrapper]:
        this.props.theme && this.props.theme === 'infographic',
    });
    const isHeaderClickable =
      (this.props.isClickableHeader ||
        (this.props.sectionData &&
          this.props.sectionData.name &&
          this.props.sectionData.name === 'News Visual Stories')) &&
      this.props.sectionData &&
      this.props.sectionData.path;

    const { sectionData } = this.props;
    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadData();
          if (this.props?.ga4Type) {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `${this.props.ga4Type}`,
              category: `${
                this.props?.ga4Category ? this.props?.ga4Category : ''
              }`,
            });
          }
        }}
        viewMargin="800px 0px 800px 0px"
        className={this.props.theme === 'cardtype1' ? 'border_none' : ''}
        id={
          sectionData && sectionData.id && sectionData.id === 'trivia'
            ? sectionData.id
            : undefined
        }
      >
        {' '}
        {this.props.sectionData?.subSections?.tabCount > 0 ? (
          <SubsectionList
            data={this.props.sectionData.subSections}
            dropdownTitle={this.props.sectionData.dropdownTitle}
            onChangeCallback={this.loadLayoutData}
            sectionId={this.props.sectionData.id}
            subHeading={this.props.sectionData.subHeading}
            showSearchBox
            gaData={{
              gaAction:
                this.props.sectionData.id !== 'fifanews'
                  ? this.props.tabChangeGaAction ||
                    `${this.props.sectionData.name}-TabChange`
                  : 'click',
              partialGaLabel: this.props.tabChangeGaLabel || 'Click',
            }}
            toggleLoader={this.toggleLoader}
            headingname={this.props.sectionData.name}
            headingLink={
              this.props.sectionData.link || this.props.sectionData.path
            }
            overrideClass={this.props.sectionData.className}
            // linkData={{
            //   // gaAction,
            //   // gaLabel:
            //     (this.props.sectionData.path && this.props.sectionData.path.indexOf('http') > -1) ||
            //     (this.props.sectionData.link && this.props.sectionData.link.indexOf('http') > -1)
            //       ? this.props.sectionData.link || this.props.sectionData.path
            //       : `${TOI_LIVE_DOMAIN}${this.props.sectionData.link || this.props.sectionData.path}`,
            // }}
            usePopupPortal={this.props.usePopupPortal}
            poweredByHtml={this.props.sectionData.poweredByHtml}
            setActiveTab={this.setActiveTab}
            // geoCityData={geoCityData}
            cardDefaultTab="null"
            sponsoredData={{
              sponsoredClass: this.props.sectionData.sponsoredClass,
              sponsoredLink: this.props.sectionData.sponsoredLink,
              sponsoredLogomsid: this.props.sectionData.sponsoredLogomsid,
              sponsoredTxt: this.props.sectionData.sponsoredTxt,
            }}
            sponsoredAd={this.props.sectionData.sponsoredAds}
            isPrime={this.props.isPrime}
            datads={this.props.sectionData}
            ga4Type={this.props?.ga4Type}
            ga4Category={this.props?.ga4Category}
          />
        ) : null}
        {(this.state.items && this.state.items.length >= 0) ||
        (this.props.sectionData &&
          this.props.sectionData.items &&
          this.props.sectionData.items.length > 0) ? (
          <div
            className={`${s.Slider_wrapper} ${themeName} ${sliderId} ${
              this.props.wrapperClass
            } ${feedclass && s[feedclass]} ${
              this.props.theme === 'cardtype1' ? s.vsCard : ''
            }`}
            ref={this.ref}
          >
            {isHeaderClickable ? (
              <div className={s.widgetHeading}>
                <Link
                  to={this.props.sectionData.path}
                  onClick={() =>
                    sendGaThroughProps({
                      data: {
                        gaAction: 'click_section_header',
                        gaLabel: `${TOI_LIVE_MOBILE_DOMAIN}${
                          this.props.sectionData.path
                        }`,
                      },
                    })
                  }
                >
                  {this.props.sectionData.name}
                </Link>
              </div>
            ) : (
              <div className={s.widgetHeading}>
                {this.props.sectionData?.subSections?.tabCount > 0
                  ? ''
                  : this.props.sectionData.name}
              </div>
            )}
            {this.props.isloadable && this.state.isLoading && <LoaderSpinner />}
            {this.getSliderHtml(this.props.theme === 'cardtype1')}
            {this.props.sectionData.path && this.moreCTA()}
          </div>
        ) : null}
      </InViewObserver>
    );
  }
}

MixedSlider.contextType = UseIntersectionObeserver;
MixedSlider.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string,
  }),
  theme: PropTypes.string,
  gaData: PropTypes.shape({}),
  wrapperClass: PropTypes.string,
  clickGaAction: PropTypes.shape({}),
  isClickableHeader: PropTypes.bool,
  isloadable: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
MixedSlider.defaultProps = {
  sectionData: {},
  theme: '',
  gaData: null,
  wrapperClass: '',
  clickGaAction: null,
  isClickableHeader: false,
  isloadable: false,
  ga4Type: '',
  ga4Category: '',
};

export default MixedSlider;
